import React, {useState,useEffect, useRef} from "react";
import styled from "styled-components";
import { FaBars } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { deviceSize } from "../../components/responsive"; 
import { BrandLogo } from "../../components/brandLogo";
import { Link, useNavigate } from "react-router-dom";
import "./navbar.css"
import { SideBar } from "../sidebar";
import { Navigate } from "react-router-dom";


const AccessibilityContainer = styled.div` 
	display:flex;
	flex-direction: row;
	align-items:center;
	width: 100%;

	@media screen and(max-width: 768px){
		justify-content: space-between;
	}
`;

const MobileIcon = styled.div`
 	display: none ;
 	

  @media screen and (max-width: ${deviceSize.mobile}px){
 	 
 	 display: block ;	
 	 position: absolute;
 	 top:30px;
 	 right:20px;
 	 transfrom:translate(-100,60%);
 	 font-size:1.8rem;
 	 cursor:pointer;
 	 color:#000;
 }

`;

const StyledButtonLink = styled.a`
	
`;

const MobileCareersButton = styled.button`
	margin-left: 45%;
	border-radius: 50px;
	background: rgba(0, 0, 0, 0.65);
	color: #FFF;
	font-size: 12px;
	height: 30%;
	width: 30%;
	font-family: sunflower;
`;


export function Navbar(){
	const [solutionsDropdownOpen, setSolutionsDropdownOpen] = useState(false)
	const [expWayDropdownOpen, setExpWayDropdownOpen] = useState(false);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	const isMobile =  useMediaQuery({ maxWidth: deviceSize.mobile });
	const navbarRef = useRef(null);

	const navigate = useNavigate();
	const handleCareersClick = () => {
		navigate("/careers");
		window.scrollTo(0, 0);
	}

	useEffect(() => {
		const handleClickOutside = (event) => {
		  if (navbarRef.current && !navbarRef.current.contains(event.target)) {
			// Clicked outside the navbar, close the dropdown menus
			setSolutionsDropdownOpen(false);
			setExpWayDropdownOpen(false);
		  }
		};
	
		document.addEventListener('click', handleClickOutside);
	
		return () => {
		  document.removeEventListener('click', handleClickOutside);
		};
	  }, []);

	const toggleDropdown = () => {
		setSolutionsDropdownOpen(!solutionsDropdownOpen)
		if (expWayDropdownOpen){
			setExpWayDropdownOpen(false)
		}
	}

	const toggleExpWayDropdown = () => {
    setExpWayDropdownOpen(!expWayDropdownOpen);

    if (solutionsDropdownOpen) {
      setSolutionsDropdownOpen(false);
    }
  };

  const toggleSidebar = () => {
	setIsSidebarOpen(!isSidebarOpen)
  }

	return(
		<nav ref={navbarRef} className="navbar">
			<BrandLogo
				ptSize={10}
				mlsize={isMobile? 10: 0}
				lhsize={isMobile ? 33 :47 } 
				lwsize={isMobile ? 33 :95 } 
		  		textSize={isMobile ? 14 : 18  }
		  		color={"#000"}
			/>
			{isMobile ? (
				<AccessibilityContainer id="accessibility-container">
					<MobileCareersButton onClick={handleCareersClick}>CAREERS</MobileCareersButton>
					<MobileIcon id="mobile-icon" onClick={toggleSidebar}>
					{isSidebarOpen && <SideBar isOpen={isSidebarOpen} toggle={toggleSidebar} />}
						<FaBars/>
					</MobileIcon>
				</AccessibilityContainer>
			) : (
				<ul className="nav-list">
				<li className={`dropdown ${solutionsDropdownOpen ? 'clicked' : ''}`}
					onMouseEnter={toggleDropdown}
					onMouseLeave={toggleDropdown}
				>
					Solutions
					{solutionsDropdownOpen && (
						<ul className="dropdown-menu">
						<li> <a href="/staffing">Staffing Pages</a> </li>
						<li> <a href="/techstaffing">Tech Staffing</a> </li>
						<li> <a href="/financestaffing">Finance Staffing</a> </li>
						<li> <a href="/callcenterstaffing">Call Center Staffing</a> </li>
						<li> <a href="/healthcompliance">Health Compliance</a> </li>
					</ul>
					)}
				</li>
				<li className={`dropdown ${expWayDropdownOpen ? 'clicked' : ''}`}
					onMouseEnter={toggleExpWayDropdown}x
					onMouseLeave={toggleExpWayDropdown}
				>
					The Exp Way
					{expWayDropdownOpen && (
					<ul className="dropdown-menu">
						<li> <a href="/staffing">Our Process</a> </li>
						<li> <a href="/careers">Professional Development</a> </li>
						<li> <a href="/getfoodnyc">GetFoodNYC Case Study</a> </li>
					</ul>
					)}
				</li>
				<li>
					<a href="/blogs" className="nav-link">Blog</a>
					{/* <Link className="nav-link" to="/blogs">Blog</Link> */}
				</li>
				<li>
					<Link to="/careers" onClick={() => window.scrollTo(0, 0)}>
						<button className="nav-button">
						CAREERS
						</button>
					</Link>
				</li>
			</ul>
			)}
		</nav>
	)
}


